import { FC } from 'react';

import { useTitle } from 'src/hooks/useTitle';

import OrderHistory from 'src/components/templates/OrderHistory/OrderHistory';

const OrderHistoryPage: FC = () => {
  useTitle('GU | 주문 히스토리');
  return <OrderHistory />;
};

export default OrderHistoryPage;
